module.exports = __webpack_public_path__ + "e9bdff98d40935435cea0a9096ed857e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-baseball-s.png
// module id = 1329
// module chunks = 0